import { FacebookAuthProvider, GoogleAuthProvider, createUserWithEmailAndPassword, sendPasswordResetEmail, signInWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import Styles from "./Signin.module.scss";
import { auth, facebookAuthProvider, googleAuthProvider } from "../../useFirebaseInit";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../contexts/AppContext";
import classnames from "classnames"
import { ReactComponent as EyeIcon } from "../../icons/extra_icons/eye.svg"
import { AuthContext } from "../../contexts/AuthContext";
import { useDispatch } from "react-redux";
import { closeWindow } from "../../actions";
import { APP_KEY_IDS } from "../../constants/constants";

interface SignInProps {
}

const Signin = ({
}: SignInProps) => {

    const { isMobile } = useContext(AppContext)
    const { setUser } = useContext(AuthContext)
    const dispatch = useDispatch()


    const [isManualSignIn, setIsManualSignIn] = useState(false)
    const [message, setMessage] = useState({
        type: "",
        message: ""
    })
    const [passwordVisible, setPasswordVisible] = useState(false)
    const [loginInfo, setLoginInfo] = useState({
        email: "",
        password: ""
    })

    const closeSignInWindow = () => {
        dispatch(closeWindow(APP_KEY_IDS.AUTH))
    }

    const signinwithEmailPassword = (type:string) => {

        if(type==="signup"){
            signupEP()
        }
        else{
            signInEP()
        }
    }

    function extractAndConvertError(text:string) {
        const errorRegex = /Firebase: Error \(auth\/([^)]+)\)/;
        const match = text.match(errorRegex);
      
        if (match) {
          const errorCode = match[1];
          const convertedErrorCode = errorCode.split('-').join(' ').toUpperCase();
          return convertedErrorCode;
        } else {
          return null;
        }
      }

    const signInEP=()=>{
        
        signInWithEmailAndPassword(auth, loginInfo.email.trim(), loginInfo.password.trim())
            .then((userCredential) => {
                const user = userCredential.user;
                if (user) {
                    setUser({
                        userName: user.displayName || "",
                        userId: user.uid,
                        pfpUrl: user.photoURL || "",
                        email: user.email || "",
                        isEmailVerified: user.emailVerified || false
                    })

                    closeSignInWindow()
                }
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                setMessage({
                    type: "error",
                    message: extractAndConvertError(error.message) || ""
                })
            });
    }


    const signupEP=()=>{
        
        createUserWithEmailAndPassword(auth, loginInfo.email.trim(), loginInfo.password.trim())
            .then((userCredential) => {
                const user = userCredential.user;
                if (user) {
                    setUser({
                        userName: user.displayName || "",
                        userId: user.uid,
                        pfpUrl: user.photoURL || "",
                        email: user.email || "",
                        isEmailVerified: user.emailVerified || false
                    })
                    closeSignInWindow()
                }
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                setMessage({
                    type: "error",
                    message: extractAndConvertError(error.message) || ""
                })
            });
    }

    const signinwithgoogle = async () => {
        signInWithPopup(auth, googleAuthProvider)
            .then((result) => {
                const credential = GoogleAuthProvider.credentialFromResult(result);
                const token = credential?.accessToken;
                const user = result.user;
                if (user) {
                    setUser({
                        userName: user.displayName,
                        userId: user.uid,
                        pfpUrl: user.photoURL,
                        email: user.email,
                        isEmailVerified: user.emailVerified
                    })
                    closeSignInWindow()
                }
            }).catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                const email = error.customData.email;
                const credential = GoogleAuthProvider.credentialFromError(error);
            });

    };

    const signinwithfacebook = () => {
        signInWithPopup(auth, facebookAuthProvider)
            .then((result) => {
                const user = result.user;
                const credential = FacebookAuthProvider.credentialFromResult(result);
                if (credential) {
                    const accessToken = credential.accessToken;
                }
            })
            .catch((error) => {
                // Handle Errors here.
                const errorCode = error.code;
                const errorMessage = error.message;
                // The email of the user's account used.
                const email = error.customData.email;
                // The AuthCredential type that was used.
                const credential = FacebookAuthProvider.credentialFromError(error);

                // ...
            });
    }

    const resetPassword = () => {
        sendPasswordResetEmail(auth, loginInfo.email)
            .then(() => {
                setMessage({
                    type: "info",
                    message: `Reset password email sent to ${loginInfo.email}`
                })
            })
            .catch((error) => {
                const errorMessage = error.message;
                setMessage({
                    type: "error",
                    message: errorMessage
                })
            });

    }

    const verifyEmailInput = () => {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        return emailRegex.test(loginInfo.email);
    }

    const verifyInputs = () => {
        return loginInfo.email && loginInfo.password && verifyEmailInput()
    }

    return (
        <div className={Styles.container}>
            <div className={Styles.header}>
                SignIn
            </div>
            {isManualSignIn ? (
                <div className={Styles.inputs}>
                    <div className={Styles.in_con}>
                        <label className={Styles.labels}>Email</label>
                        <input type="email" value={loginInfo.email} className={Styles.input} id="email" placeholder='Email' onChange={(e) => { setLoginInfo({ ...loginInfo, email: e.target.value }) }} ></input>
                    </div>

                    <div className={Styles.in_con}>
                        <label className={Styles.labels}>Password</label>
                        <input type={passwordVisible ? "text" : "password"} value={loginInfo.password} className={classnames(Styles.input, Styles.password)} id="passowrd" placeholder='Password' onChange={(e) => { setLoginInfo({ ...loginInfo, password: e.target.value }) }} ></input>
                        <div className={classnames(Styles.icon, !passwordVisible && Styles.disabled)}>
                            <EyeIcon onClick={() => { setPasswordVisible(!passwordVisible) }} />
                        </div>
                    </div>
                    <div className={Styles.forgot} onClick={resetPassword}>
                        {verifyEmailInput() && "Forgot Password"}
                    </div>

                    <div className={classnames(Styles.message, message.type === "error" ? Styles.error : Styles.info)}>
                        {message.message}
                    </div>
                    <div className={Styles.ctas}>
                        <div className={classnames(Styles.cta,Styles.signup, !verifyInputs() && Styles.disabled)} onClick={()=>{signinwithEmailPassword("signup")}}>
                            Sign up
                        </div>
                        <div className={classnames(Styles.cta,Styles.login, !verifyInputs() && Styles.disabled)} onClick={()=>{signinwithEmailPassword("login")}}>
                            Login
                        </div>
                    </div>

                </div>
            ) : (
                <div className={Styles.login_buttons}>
                    <button className={classnames(Styles.buttons, isMobile && Styles.disabled)} id="gogls" disabled={isMobile} onClick={signinwithgoogle}>
                        <img src="https://media4.giphy.com/media/2epS8zhisYtHDCKrWv/giphy.gif" />
                        <div className={Styles.label}>SignIn With Google</div>
                    </button>
                    <button className={classnames(Styles.buttons, isMobile && Styles.disabled)} id="faces" disabled={isMobile} onClick={signinwithfacebook}>
                        <img src="https://media1.giphy.com/media/VhbnQX5NKhNFQUzOVp/giphy.gif?cid=6c09b952dqx8fkhw81kxr2djhy0veo518pqbn874ig9cayxq&rid=giphy.gif&ct=s" />
                        <div className={Styles.label}>SignIn With Facebook</div>
                    </button>
                    <button className={Styles.buttons} id="faces" onClick={() => { setIsManualSignIn(true) }}>
                        <img src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ffreepngimg.com%2Fdownload%2Fiphone%2F64645-icons-computer-email-address-png-file-hd.png&f=1&nofb=1&ipt=6881ab3f3eefdb663fce8583c20e2c85034e0866c3537306e1fdb67548938192&ipo=images" />
                        <div className={Styles.label}>SignIn With Email & Password</div>
                    </button>
                </div>
            )}

        </div>
    )
}

export default Signin
